import script from "./moduleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./moduleDialog.vue?vue&type=script&setup=true&lang=js"

import "./moduleDialog.vue?vue&type=style&index=0&id=41ef508f&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ef508f"]])

export default __exports__